import { Tag as Tag$1 } from '@teko/ds-foundation';
import slug from '@teko/slug';
import { styled, CustomLink, Tag } from '@teko/ui';
import React, { useState } from 'react';
import { t } from '../../i18n.es.js';
import { StyledProductPrice, GiftName, StyledSpan } from '../../mobile/OrderProductLine/OrderProductLine.es.js';
import { ListItem } from '../../mobile/ListItem/ListItem.es.js';
import { OrderImage } from '../../mobile/OrderImage/OrderImage.es.js';
import { Text } from '../../mobile/Text/Text.es.js';

const PromotionLine = styled.div`
  margin-top: 4px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
`;
const GiftsWrapper = styled.div`
  background: #f8f8fc;
  margin-top: -10px;
  padding: 8px 16px;
  margin: 0 16px 0 32px;
  border-radius: 8px;
  margin-bottom: 16px;
`;
const SellerInfo = styled.div`
  padding-bottom: 8px;
  display: flex;
`;
const StyledDiv = styled.div`
  text-align: right;
`;
const NoteWrapper = styled.div`
  margin: 2px 16px;
`;
const ItemNote = styled.div(({ maxHeight, line, expanded, theme }) => {
  return `
  display: -webkit-box;
  -webkit-line-clamp: ${expanded ? "unset" : line};
  -webkit-box-orient: vertical;
  overflow: hidden;
  cursor: pointer;
  max-height: ${expanded ? "fit-content" : maxHeight};
  width: 100%;
  line-height: 1.5em;
  white-space: normal;
  font-style: italic;
  color: ${theme.colors.neutral};
  word-break: break-word;
  overflow-wrap: break-word;
  padding-right: 0.25em;
`;
});
const OrderProductLine = ({
  product,
  showGiftQty = true
}) => {
  const {
    sku,
    imageUrl,
    name,
    displayName,
    sellerName,
    price,
    unitAdd,
    prizes,
    productTag,
    quantity,
    clearanceTypeTag,
    sellerSku,
    formattedValue,
    note
  } = product;
  const [expanded, setExpanded] = useState(false);
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(ListItem, {
    left: /* @__PURE__ */ React.createElement(OrderImage, {
      width: "80px",
      images: [imageUrl || ""]
    }),
    title: /* @__PURE__ */ React.createElement(CustomLink, {
      targetPath: `/${name ? slug(name) : ""}--s${sku}`,
      targetType: "_blank",
      passHref: true
    }, /* @__PURE__ */ React.createElement(Text, {
      fontSize: 14,
      fontWeight: "400",
      maxLines: 2,
      marginBottom: "5px"
    }, productTag && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Tag, {
      variant: "primary"
    }, productTag), "\xA0"), clearanceTypeTag && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Tag$1, {
      type: "secondary",
      variant: "branding",
      content: clearanceTypeTag
    }), "\xA0"), displayName || name)),
    subTitle: /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Text, {
      fontSize: 12,
      color: "#82869E"
    }, "SKU: ", sellerSku || sku), !!sellerName && /* @__PURE__ */ React.createElement(SellerInfo, null, /* @__PURE__ */ React.createElement(Text, {
      color: "#82869E",
      fontSize: 13
    }, t("Cung c\u1EA5p b\u1EDFi"), /* @__PURE__ */ React.createElement(React.Fragment, null, "\xA0")), /* @__PURE__ */ React.createElement(Text, {
      color: "#1782E6",
      fontSize: 13
    }, sellerName))),
    right: /* @__PURE__ */ React.createElement(StyledDiv, null, /* @__PURE__ */ React.createElement(StyledProductPrice, {
      price: price || 0,
      formattedValue,
      consultationServiceFee: unitAdd || 0
    }), /* @__PURE__ */ React.createElement(Text, {
      textAlign: "right",
      fontSize: 12,
      color: "#848788"
    }, "X", quantity == null ? void 0 : quantity.toLocaleString("vi-VN")))
  }), !!(prizes == null ? void 0 : prizes.length) && /* @__PURE__ */ React.createElement(GiftsWrapper, null, prizes.map((gift) => /* @__PURE__ */ React.createElement(PromotionLine, {
    key: gift.name
  }, /* @__PURE__ */ React.createElement(OrderImage, {
    width: "32px",
    images: gift.imageUrl ? [gift.imageUrl] : []
  }), /* @__PURE__ */ React.createElement(GiftName, null, showGiftQty && /* @__PURE__ */ React.createElement(StyledSpan, null, `${gift.quantity.toLocaleString("vi-VN")}x`), ` ${gift.name}`)))), !!note && /* @__PURE__ */ React.createElement(NoteWrapper, null, /* @__PURE__ */ React.createElement(ItemNote, {
    maxHeight: "4.5em",
    expanded,
    line: 3,
    onClick: () => setExpanded(!expanded)
  }, `${t("Ghi ch\xFA")}: ${note}`)));
};

export { OrderProductLine };
